import { WidgetColumn } from './Dashboard.model';
import { MetricIdEnum, WidgetType } from '../../features/metrics/Metrics.model';

export const KpiWidgetsConfig: WidgetColumn[] = [
  {
    span: 1,
    widget: { widgetType: WidgetType.KPI, metricId: MetricIdEnum.avgChargingSession },
  },
  {
    span: 1,
    widget: { widgetType: WidgetType.KPI, metricId: MetricIdEnum.revenue },
  },
  { span: 1, widget: { widgetType: WidgetType.KPI, metricId: MetricIdEnum.energyDelivered } },
  { span: 1, widget: { widgetType: WidgetType.KPI, metricId: MetricIdEnum.totalChargingTime } },
  {
    span: 1,
    widget: {
      widgetType: WidgetType.KPI,
      metricId: MetricIdEnum.avgStationUtilization,
    },
  },
  { span: 1, widget: { widgetType: WidgetType.KPI, metricId: MetricIdEnum.electricMilesEnabled } },
  { span: 1, widget: { widgetType: WidgetType.KPI, metricId: MetricIdEnum.iceEmissionsAvoided } },
  {
    span: 2,
    widget: { widgetType: WidgetType.MAP },
  },
  {
    span: 2,
    widget: {
      widgetType: WidgetType.LINE_CHART,
      metricId: MetricIdEnum.timeBasedUtilization,
      hasLocationFilter: true,
    },
  },
];
